import { Col, Row } from 'react-bootstrap';
import BiasChartML from './BiasChartMl';
import BiasChartLLM from './BiasChartLLM';
import { useSelector } from 'react-redux';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {
  isProjectDetailsLoading,
  selectProjectResults
} from '../../project-details/data-access/project.reducer';

export const BiasCard = () => {
  const projectResults = useSelector(selectProjectResults); // Fetch from Redux Store
  const isLoading = useSelector(isProjectDetailsLoading);
  console.log('BIAS LOADING', isLoading);
  return (
    <>
      {isLoading ? (
        <Backdrop
          sx={theme => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : projectResults?.results?.bias ? ( // ✅ Removed unnecessary brackets around the condition
        <Row className="g-3">
          <Col xs={12} md={6}>
            <BiasChartLLM
              description="Identifies and quantifies bias in LLM outputs by analyzing sensitive attributes."
              title="BIAS - LLM"
              data={projectResults.results.bias.LLMBiasDetection} // ✅ Fixed: Passing correct LLM bias data
            />
          </Col>

          <Col xs={12} md={6}>
            <BiasChartML
              description="Identifies and quantifies bias in ML models by analyzing sensitive attributes."
              title="BIAS - ML"
              data={projectResults.results.bias.ML_Bias_Detection} // ✅ Correct ML bias data
            />
          </Col>
        </Row>
      ) : null}
    </>
  );
};
